import React from 'react';
import Table from 'components/Table';
import { SortColumn } from 'components/Table/Table.types';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { IProject } from 'pages/Projects/Projects.types';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

interface ProjectsTableProps {
  projects: IProject[];
  sortColumn: SortColumn;
  onPreview: (id: string) => void;
  onSort: (sortColumn: SortColumn) => void;
}

const ProjectsTable: React.FunctionComponent<ProjectsTableProps> = ({
  projects,
  sortColumn,
  onPreview,
  onSort,
}) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const columns =
    width < 490
      ? [
          {
            key: 'preview',
            content: (project: IProject) => (
              <Button
                onClick={() => onPreview(project.id)}
                size='small'
                sx={{ minWidth: 0 }}
              >
                <i className='fas fa-eye' />
              </Button>
            ),
            width: '10%',
          },
          {
            path: 'title',
            label: t('projects.title'),
            content: (project: IProject) => (
              <a href={project.url} target='_blank' rel='noreferrer'>
                {project.title}
              </a>
            ),
            width: '40%',
          },
          { path: 'dates', label: t('projects.dates'), width: '50%' },
        ]
      : [
          {
            key: 'preview',
            content: (project: IProject) => (
              <Button
                onClick={() => onPreview(project.id)}
                size='small'
                sx={{ minWidth: 0 }}
              >
                <i className='fas fa-eye' />
              </Button>
            ),
            width: '5%',
          },
          {
            path: 'title',
            label: t('projects.title'),
            content: (project: IProject) => (
              <a href={project.url} target='_blank' rel='noreferrer'>
                {project.title}
              </a>
            ),
            width: '15%',
          },
          { path: 'techStack', label: t('projects.techStack'), width: '25%' },
          {
            path: 'description',
            label: t('projects.description'),
            width: '40%',
          },
          // { path: 'sourceCode', label: 'Code' },
          { path: 'dates', label: t('projects.dates'), width: '15%' },
        ];

  return (
    <Table
      columns={columns}
      sortColumn={sortColumn}
      data={projects}
      onSort={onSort}
    />
  );
};

export default ProjectsTable;
